import React from "react";
import { motion } from "framer-motion";

// 4-point Googie starburst
export const Starburst = ({ className = "", color = "currentColor" }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <path
      d="M50 0 C54 34 66 46 100 50 C66 54 54 66 50 100 C46 66 34 54 0 50 C34 46 46 34 50 0 Z"
      fill={color}
    />
  </svg>
);

const easeOut = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.75, ease: easeOut, delay }}
    >
      {children}
    </MotionTag>
  );
};

export const Overline = ({ children, className = "" }) => (
  <div
    className={`inline-flex items-center gap-2 text-xs md:text-sm font-bold uppercase tracking-[0.22em] text-jet-teal-deep ${className}`}
  >
    <Starburst className="h-3 w-3 text-jet-amber" />
    {children}
  </div>
);

export const SectionHeading = ({ overline, title, className = "" }) => (
  <div className={className}>
    {overline && <Overline className="mb-5">{overline}</Overline>}
    <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95] text-jet-ink max-w-4xl text-balance">
      {title}
    </h2>
  </div>
);
